var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElisyanHeaderbackgroundHd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid slice",
    width: 3862,
    height: 503,
    viewBox: "0 0 3862 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8075_19536)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3862,
    height: 503,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3862,
    height: 503,
    fill: "url(#paint0_linear_8075_19536)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.679 648.235C626.708 342.899 1208.27 123.838 1651.95 107.478C2163.25 88.664 2367.9 343.625 2753.19 245.669C3104.79 156.366 3113.97 -101.752 3373.06 -154.178C3611.17 -202.351 3997.72 -64.1762 4658.17 676.92",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4629.91 712.383C3977.57 -17.936 3590.53 -162.107 3348.7 -120.673C3169.48 -89.7872 3105.71 38.2545 2969.13 142.297C2901.03 195.754 2816.13 236.545 2722.06 261.008C2413.92 341.316 2221.78 203.434 1886.42 155.82C1800.93 143.498 1713.42 138.53 1625.71 141.017C1180 152.602 603.855 345.772 549.206 640.504",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4601.58 747.745C3957.35 28.2567 3570.03 -121.868 3325 -87.1441C3144.88 -61.6077 3076.71 60.6683 2939.62 159.763C2869.75 211.489 2784.94 251.353 2691.65 276.317C2388.04 357.517 2196.64 234.15 1860.25 189.514C1774.76 178.041 1687.59 173.036 1600.12 174.58C1152.35 182.386 581.651 348.616 517.382 632.744",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4573.31 782.999C3937.34 74.4909 3549.54 -81.526 3301 -53.6548C3119.85 -33.357 3047.57 83.0356 2909.74 177.244C2838.26 227.204 2753.6 266.16 2661.17 291.627C2361.81 373.733 2171.79 264.8 1834.02 223.21C1748.48 212.45 1661.53 207.359 1574.24 207.998C1124.46 211.447 559.225 351.313 485.336 624.837",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4545.05 818.515C3917.18 120.68 3529.19 -41.1373 3276.93 -20.1094C3094.96 -5.00791 3018.21 105.518 2879.72 194.68C2806.57 242.9 2721.91 280.993 2630.17 306.962C2335.07 389.972 2146.22 295.536 1806.91 256.946C1721.5 247.036 1634.97 241.919 1548.07 241.639C1096.21 240.735 536.443 354.288 452.861 617.212",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4517.08 853.914C3897.1 166.867 3508.39 -5.80407 3252.86 13.3844C3070.46 26.9356 2988.84 127.635 2849.84 212.162C2775.06 258.562 2690.4 295.787 2599.4 322.287C2308.54 406.203 2121 326.255 1780.68 290.695C1695.33 281.5 1609.09 276.308 1522.48 275.15C1068.52 269.683 514.237 357.081 421.038 609.452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4488.45 889.343C3876.94 213.109 3488.5 40.0078 3228.85 46.6147C3045.49 51.9404 2959.33 150.073 2819.89 229.701C2743.56 274.26 2658.9 310.639 2568.63 337.665C2282.01 422.486 2095.57 356.986 1754.15 324.459C1668.86 316.042 1582.9 310.809 1496.6 308.78C1040.56 298.959 491.734 359.835 388.922 601.76",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4460.2 924.752C3857.01 259.287 3468.23 80.2867 3204.8 80.4191C3020.76 80.3331 2929.66 172.044 2789.95 247.131C2712.13 289.808 2627.42 325.326 2537.86 352.83C2255.56 438.606 2070.22 387.657 1727.63 358.01C1647.91 351.178 1562.87 345.008 1470.72 342.144C1012.51 327.817 469.25 362.743 356.813 593.959",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4431.94 960.164C3836.71 305.534 3447.98 121.142 3180.8 113.804C2996.03 108.78 2899.92 194.073 2759.85 264.518C2680.54 305.292 2595.74 340.016 2506.87 368.112C2228.82 454.793 2044.71 418.233 1700.88 391.729C1620.84 385.54 1536.01 379.465 1444.55 375.681C984.832 356.869 446.755 365.6 324.695 586.16",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4403.61 995.528C3816.56 351.726 3427.72 161.895 3156.74 147.457C2971.31 137.543 2869.83 216.225 2730.12 282.048C2649.43 320.892 2564.55 354.84 2476.39 383.53C2202.52 471.12 2019.58 449.056 1674.57 425.327C1594.55 419.765 1509.66 413.693 1418.88 409.04C956.555 385.532 424.249 368.147 292.572 578.154",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4375.34 1030.94C3796.47 397.912 3407.46 202.751 3132.88 180.94C2946.79 166.189 2840.22 238.142 2700.32 299.579C2618.25 336.415 2533.23 369.57 2445.76 398.848C2176.2 487.34 1994.43 479.719 1648.2 459.292C1567.85 454.477 1483.17 448.343 1393.15 442.87C928.727 414.644 401.979 371.256 260.537 570.666",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4347.08 1066.35C3776.32 444.151 3387.07 243.61 3108.67 214.437C2921.86 194.904 2810.11 260.028 2670.3 317.064C2589.93 349.828 2507.61 382.941 2414.85 414.177C2149.54 503.522 1968.94 510.449 1621.53 493.005C1541 488.88 1456.46 482.686 1366.98 476.404C900.461 443.459 379.198 374.071 228.21 562.926",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4318.82 1101.76C3756.18 490.548 3367.18 284.553 3084.68 247.979C2897.14 223.612 2780 281.812 2640.35 334.549C2557.95 365.678 2475.38 397.966 2384.07 429.501C2123.02 519.908 1943.65 541.119 1595.01 526.715C1514.29 523.33 1429.82 517.082 1341.25 509.921C872.692 472.148 356.848 376.87 196.243 555.173",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4290.71 1137.17C3736.09 536.581 3346.5 325.589 3060.68 281.524C2872.42 252.48 2749.88 303.547 2610.41 352.09C2525.89 381.483 2443.14 412.994 2353.59 444.868C2096.71 536.027 1918.66 571.884 1568.49 560.533C1487.51 557.788 1403.25 551.477 1315.37 543.552C844.705 500.852 334.351 379.679 164.128 547.43",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4262.23 1172.53C3715.93 582.768 3326.33 366.699 3036.61 315.015C2847.55 281.245 2719.69 325.123 2580.53 369.517C2493.9 397.122 2410.83 427.968 2322.53 460.151C2070.04 552.209 1893.01 602.516 1541.96 594.188C1457.29 591.543 1373 585.762 1289.41 576.868C816.79 529.494 311.643 382.596 132.013 539.629",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4233.97 1207.94C3695.78 629.008 3305.58 407.682 3012.83 348.494C2822.98 310.05 2689.7 346.639 2550.51 387.004C2461.77 412.77 2378.52 442.943 2291.76 475.474C2043.44 568.441 1867.65 633.241 1515.58 627.89C1431.02 626.033 1346.88 620.238 1263.68 610.54C788.856 557.824 289.361 385.391 99.8141 531.676",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4205.71 1243.36C3675.69 675.195 3284.84 449.031 2988.54 381.998C2798.05 338.978 2659.28 368.071 2520.63 404.435C2429.77 428.308 2346.36 457.965 2261.06 490.797C2017.06 584.665 1842.36 663.912 1488.91 661.608C1404.46 660.47 1320.46 654.607 1237.65 644.071C761.016 586.518 266.869 388.249 67.7115 524.139",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4177.37 1278.77C3655.55 721.645 3264.67 490.197 2964.54 415.54C2773.04 367.856 2629.07 389.389 2490.75 421.916C2397.48 443.806 2314.12 472.938 2230.28 506.121C1990.53 600.79 1817.08 694.634 1462.38 695.37C1378.05 694.918 1294.18 688.986 1211.77 677.647C733.161 615.002 244.369 391.054 35.5939 516.392",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4149.11 1314.18C3635.75 767.61 3244.08 531.487 2940.49 449.244C2748.12 396.992 2598.95 410.86 2460.82 439.715C2365.66 459.756 2281.76 488.284 2199.53 521.76C1964.02 617.439 1791.74 725.674 1435.87 729.289C1351.66 729.524 1267.9 723.523 1185.9 711.38C705.32 643.592 221.533 394.242 3.49485 508.856",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4120.85 1349.59C3615.31 813.864 3223.41 572.78 2916.48 482.576C2723.11 425.713 2568.79 431.808 2430.86 456.886C2333.56 474.616 2249.58 502.991 2168.75 536.874C1937.56 633.456 1766.45 756.135 1409.34 762.894C1325.26 763.842 1241.59 757.77 1160.02 744.798C677.525 671.707 199.385 396.717 -28.628 500.899",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4092.52 1384.96C3595.16 860.054 3202.75 614.335 2892.71 516.057C2698.4 454.683 2539.01 452.897 2401.28 474.355C2301.84 489.828 2217.63 517.951 2138.34 552.026C1911.33 649.569 1741.38 786.744 1383.1 796.487C1299.13 798.095 1215.53 791.952 1134.35 778.208C650.291 699.379 177.183 399.562 -60.5977 493.095",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4064.33 1420.36C3270.41 585.969 2729.72 445.14 2371.03 491.851C1979.47 542.835 1841.47 812.95 1356.29 830.26C787.12 850.509 196.316 388.325 -92.8605 485.352",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8075_19536",
    x1: 1931,
    y1: 0,
    x2: 1931,
    y2: 503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3AAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#880098"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8075_19536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3862,
    height: 503,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElisyanHeaderbackgroundHd);
export default __webpack_public_path__ + "static/media/Elisyan Header background HD.e2181cdec8c515b74ff4007c344e972b.svg";
export { ForwardRef as ReactComponent };